// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/branches.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { BranchService } from "./branches_pb";

/**
 * @generated from rpc chalk.server.v1.BranchService.StartBranchDeployment
 */
export const startBranchDeployment = BranchService.method.startBranchDeployment;

/**
 * @generated from rpc chalk.server.v1.BranchService.GetBranchDeploymentState
 */
export const getBranchDeploymentState = BranchService.method.getBranchDeploymentState;

/**
 * @generated from rpc chalk.server.v1.BranchService.GetBranchWithLatestDeployment
 */
export const getBranchWithLatestDeployment = BranchService.method.getBranchWithLatestDeployment;

/**
 * @generated from rpc chalk.server.v1.BranchService.DeleteBranch
 */
export const deleteBranch = BranchService.method.deleteBranch;

/**
 * @generated from rpc chalk.server.v1.BranchService.ListBranchWithLatestDeployments
 */
export const listBranchWithLatestDeployments = BranchService.method.listBranchWithLatestDeployments;

/**
 * @generated from rpc chalk.server.v1.BranchService.GetBranchVenvInstalledPackages
 */
export const getBranchVenvInstalledPackages = BranchService.method.getBranchVenvInstalledPackages;
